import {AfterViewInit, Component} from '@angular/core';
import {ReserveOnlineInsureAgreementCompleteFragmentController} from './ReserveOnlineInsureAgreementCompleteFragmentController';
import {MatDialog} from '@angular/material/dialog';
import {BaseViewUI} from '../../../../../BaseUI/BaseViewUI/BaseViewUI';
import {Router} from '@angular/router';

@Component({
	selector: 'app-reserve-component',
	templateUrl: './ReserveOnlineInsureAgreementCompleteFragmentComponent.html',
	styleUrls: ['../ReserveOnlineInsureAgreementLayout.scss', './ReserveOnlineInsureAgreementCompleteFragmentComponent.scss'],
})

export class ReserveOnlineInsureAgreementCompleteFragmentComponent extends BaseViewUI implements AfterViewInit {

	// 紐付いたコントローラー
	public combineCtrl: ReserveOnlineInsureAgreementCompleteFragmentController;
	public eventPrevPage: () => void;

	/**
	 * constructor
	 */
	constructor(public dialogCtrl: MatDialog,
				public route: Router) {

		super();

		// コントローラーの生成
		this.createController(ReserveOnlineInsureAgreementCompleteFragmentController);

	}

	/**
	 * ngAfterViewInit
	 *
	 * Angularのライフサイクル
	 * ビューの初期化後に一度だけ実行される
	 */
	public async ngAfterViewInit() {
	}



	/**
	 * 開始処理
	 */
	public async start() {
		this.log('ReserveOnlineInsureAgreementCompleteFragmentComponent::start()');
	}

}

